import PayRollAnylytics from "./PayRollAnyalytics/Anyalytics/Anyalytics";
import NewBudget from "./PayRollAnyalytics/BudgetEstimations/NewBudget";
import SavedBudget from "./PayRollAnyalytics/BudgetEstimations/SavedBudget";
import CompareCompensation from "./PayRollAnyalytics/CompareCompensation/CompareCompensation";
import CompensationPlaning from "./PayRollAnyalytics/CompensationPlanning/CompensationPlaning";
import EmployeeCompetatives from "./PayRollAnyalytics/EmployeeCompetativnes/EmployeeCompetatives";
import RunPayRoll from "./RunPayRoll/RunPayRoll";
import PayGroupRoutes from "./Settings/PayGroup/PayGroupRoutes";

export const PayRollRoutes = {
    PayRollAnylytics,
    CompensationPlaning,
    PayGroupRoutes,
    NewBudget,
    SavedBudget,
    CompareCompensation,
    EmployeeCompetatives,
    RunPayRoll
}